{
  "invite.title": "Välkommen till ColorGlo",
  "invite.body": "Välj ett lösenord så är du igång.",
  "invite.name": "Ditt namn",
  "invite.password": "Lösenord",
  "invite.password_hint": "Minst 12 tecken.",
  "invite.submit": "Skapa kontot",
  "invite.done": "Kontot är klart. Logga in så kommer du till kalendern.",
  "invite.missing": "Länken saknar en inbjudan. Be om en ny av din chef.",
  "auth.sign_in.title": "Logga in",
  "auth.sign_in.body": "Logga in för att komma till kalendern.",
  "auth.sign_in.email": "E-postadress",
  "auth.sign_in.password": "Lösenord",
  "auth.sign_in.submit": "Logga in",
  "auth.sign_in.working": "Loggar in …",
  "auth.sign_in.failed": "E-postadressen eller lösenordet stämmer inte.",
  "auth.sign_in.forgot": "Glömt lösenordet?",
  "auth.sign_in.no_account": "Inget konto än? Be din franchisetagare om en inbjudan.",
  "auth.sign_in.image_alt": "Arbete i en ColorGlo-verkstad",
  "auth.sign_out": "Logga ut",
  "auth.email.invitation.subject": "Du är inbjuden till {workshop}",
  "auth.email.invitation.heading": "Välkommen till {workshop}",
  "auth.email.invitation.body": "Du har bjudits in till bokningskalendern för {workshop}. Välj ett lösenord för att komma igång. Länken gäller i 14 dagar.",
  "auth.email.invitation.cta": "Skapa ditt konto",
  "auth.email.password_reset.subject": "Välj ett nytt lösenord för ColorGlo",
  "auth.email.password_reset.heading": "Nytt lösenord",
  "auth.email.password_reset.body": "{workshop} har skickat dig en länk för att välja ett nytt lösenord. Länken gäller i 24 timmar och kan bara användas en gång.",
  "auth.email.password_reset.cta": "Välj nytt lösenord",
  "auth.email.email_changed.subject": "Din inloggning till ColorGlo har ändrats",
  "auth.email.email_changed.heading": "Ny e-postadress för inloggning",
  "auth.email.email_changed.body": "{workshop} har ändrat e-postadressen du loggar in med. Kontakta din chef om du inte känner igen ändringen.",
  "auth.email.email_changed.cta": "Logga in",
  "reset.title": "Välj ett nytt lösenord",
  "reset.body": "Ditt nya lösenord ersätter det gamla. Du loggas ut på alla enheter.",
  "reset.password": "Nytt lösenord",
  "reset.password_hint": "Minst 12 tecken.",
  "reset.submit": "Spara lösenordet",
  "reset.done": "Lösenordet är sparat. Logga in med det nya lösenordet.",
  "reset.missing": "Länken saknar en återställning. Be din chef om en ny.",
  "reset.failed": "Länken fungerar inte längre. Be din chef om en ny.",
  "invite.owner_title": "Välkommen, {name}",
  "invite.owner_body": "Välj ett lösenord för verkstadens konto.",
  "invite.email": "E-post",
  "invite.activate_body": "Kontot finns redan. Aktivera för att lägga till {name}.",
  "invite.activate": "Aktivera",
  "invite.invalid": "Inbjudan är ogiltig eller har gått ut. Be om en ny.",
  "auth.change_password.title": "Byt lösenord",
  "auth.change_password.body": "Dina andra inloggningar loggas ut när lösenordet är bytt.",
  "auth.change_password.current": "Nuvarande lösenord",
  "auth.change_password.new": "Nytt lösenord",
  "auth.change_password.confirm": "Upprepa nytt lösenord",
  "auth.change_password.mismatch": "Lösenorden stämmer inte överens.",
  "auth.change_password.failed": "Nuvarande lösenord stämmer inte.",
  "auth.change_password.submit": "Byt lösenord",
  "auth.change_password.done": "Lösenordet är bytt."
}
